let anyDoc = <any> document;

export function isFullscreenSupported() {
    if (anyDoc.fullscreenEnabled) return anyDoc.fullscreenEnabled;
    if (anyDoc.webkitFullscreenEnabled) return anyDoc.webkitFullscreenEnabled;
    if (anyDoc.mozFullScreenEnabled) return anyDoc.mozFullScreenEnabled;
    if (anyDoc.msFullScreenEnabled) return anyDoc.msFullScreenEnabled;
    return false;
}

export function isFullscreen() {
    if (anyDoc.fullscreenElement) return true;
    if (anyDoc.webkitFullscreenElement) return true;
    if (anyDoc.mozFullscreenElement) return true;
    if (anyDoc.msFullscreenElement) return true;
    return false;
}

export function toggleFullscreen(): boolean {
    if (!isFullscreenSupported()) return false;

    if (!isFullscreen()) {
        if (anyDoc.documentElement.requestFullscreen) {
            anyDoc.documentElement.requestFullscreen();
            return true;
        }

        if (anyDoc.documentElement.webkitRequestFullscreen)
            anyDoc.documentElement.webkitRequestFullscreen();

        if (anyDoc.documentElement.mozRequestFullScreen)
            anyDoc.documentElement.mozRequestFullScreen();

        if (anyDoc.documentElement.msRequestFullscreen)
            anyDoc.documentElement.msRequestFullscreen();

        return true;
    }
    else {
        if (anyDoc.exitFullscreen) {
            anyDoc.exitFullscreen();
            return false;
        }

        if (anyDoc.webkitExitFullscreen)
            anyDoc.webkitExitFullscreen();

        if (anyDoc.mozCancelFullScreen)
            anyDoc.mozCancelFullScreen();

        if (anyDoc.msExitFullscreen)
            anyDoc.msExitFullscreen();

        return false;
    }
}